// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.url;
  private dataSource = new BehaviorSubject<boolean>(false);
  currentData = this.dataSource.asObservable();

  constructor(private http: HttpClient) { }

  login(email: string, password: string): Observable<any> {
    const body = { email, password };
    return this.http.post<any>(this.apiUrl + 'auth/login/email', body);
  }

  logout(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    let obj = {
      accessToken: token
    }
    return this.http.post<any>(this.apiUrl + 'auth/logout', obj, { headers: headers });
  }

  chnagePassword(Obj: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(this.apiUrl + 'user/change-password', Obj, { headers: headers });
  }

  getAllTags(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}tag/getAll`, { headers: headers });
  }

  getAllMusics(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
      'Content-Type': 'application/json'
    });

    const data = {
      id: localStorage.getItem('id'),
      email: localStorage.getItem('email'),
      username: null,
      contact: null,
      password: null,
      roles: null
    };

    return this.http.post<any>(`${this.apiUrl}release/getAll`, data, { headers: headers });
  }

  getAllNamertunes(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
      'Content-Type': 'application/json'
    });
    return this.http.get<any>(`${this.apiUrl}release/nametune/getAll`, { headers: headers });
  }

  getAllDeployments(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}service/getAll`, { headers: headers });
  }

  getMusicById(muiscId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}release/getById/${muiscId}`, { headers: headers });
  }

  getAllArtists(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}artist/getAll`, { headers: headers });
  }

  getAllFilteredMuiscList(filterData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}filteration/filterData`, filterData, { headers: headers });
  }

  onChangeMusicStatus(filterData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/updateApproval`, filterData, { headers: headers });
  }

  onDeployMusicListing(filterData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}distribution/getReleaseIds`, filterData, { headers: headers });
  }

  UpadteTagsStatus(tagsObj: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/updateTags`, tagsObj, { headers: headers });
  }

  getAllCountry(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}countries/getAll`, { headers: headers });
  }

  getAllUsers(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}user/getAll`, { headers: headers });
  }

  getAllpublishers(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}publisher/getAll`, { headers: headers });
  }

  getAllLanguages(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}language/getAll`, { headers: headers });
  }

  getAllRoles(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}role/getAll`, { headers: headers });
  }

  getAllGeneres(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get<any>(`${this.apiUrl}category/getAll`, { headers: headers });
  }

  addTag(tagData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}tag/add`, tagData, { headers: headers });
  }

  updateTag(tagData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}tag/update`, tagData, { headers: headers });
  }

  addDeployment(deploymentData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}service/add`, deploymentData, { headers: headers });
  }

  addArtist(artistData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}artist/add`, artistData, { headers: headers });
  }

  addGenre(categoryData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}category/add`, categoryData, { headers: headers });
  }

  addUser(userData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}user/add`, userData, { headers: headers });
  }

  addPublisher(userData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}publisher/add`, userData, { headers: headers });
  }

  addMusic(musicData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post<any>(`${this.apiUrl}release/add`, musicData, { headers: headers });
  }

  updateMusic(musicId: any, musicData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/update/${musicId}`, musicData, { headers: headers });
  }

  updateDeployment(deploymentData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}service/update`, deploymentData, { headers: headers });
  }

  updateArtist(publisherData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}artist/update`, publisherData, { headers: headers });
  }

  updatePublsiher(publisherData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}publisher/update`, publisherData, { headers: headers });
  }

  updateGenres(categoryData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}category/update`, categoryData, { headers: headers });
  }

  updateUser(userData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}user/update`, userData, { headers: headers });
  }

  updateRole(roleData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}role/update`, roleData, { headers: headers });
  }

  deleteTag(tagId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}tag/delete`, {
      body: tagId,
      headers: headers,
    });
  }
  deleteDeployments(deploymentId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}service/delete`, {
      body: deploymentId,
      headers: headers,
    });
  }
  deleteArtist(artistId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}artist/delete`, {
      body: artistId,
      headers: headers,
    });
  }
  deleteGenres(genreId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}category/delete`, {
      body: genreId,
      headers: headers,
    });
  }
  deleteUser(userId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}user/delete`, {
      body: userId,
      headers: headers,
    });
  }
  deletePublisher(publisherId: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.request<any>('DELETE', `${this.apiUrl}publisher/delete`, {
      body: publisherId,
      headers: headers,
    });
  }
  deleteMusic(muiscId: string): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.delete<any>(`${this.apiUrl}release/delete/${muiscId}`, { headers: headers });
  }

  getAllRequestedNamertune(): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl}nametune/getAll`, { headers: headers })
  }

  addNamertune(namertuneData: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post(`${this.apiUrl}release/add/nametuneauto`, namertuneData, { headers: headers })
  }

  rejectNamertune(namertuneData: any): Observable<any> {
    const token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    })
    return this.http.put(`${this.apiUrl}nametune/updateStatus`, namertuneData, { headers: headers })
  }

  updateData(newData: any) {
    this.dataSource.next(newData);
  }

  getPublisher(id: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.get(`${this.apiUrl}publisher/getById/${id}`, { headers: headers })
  }

  getPublisherEmail(data: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.post(`${this.apiUrl}publisher/getByEmail`, data, { headers: headers })
  }

  getPublisherDataByID(id: number): Observable<any> {
    const token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*'
    })
    return this.http.get(`${this.apiUrl}publisher/getById/${id}`, { headers: headers })
  }

  mulitpleDeploy(data: any): Observable<any> {
    const token = localStorage.getItem('token')
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
      'Content-Type': 'application/json'
    })
    return this.http.post(`${this.apiUrl}distribution/getReleaseIds`, data , { headers })
  }

  multipleApprove(data: any): Observable<any> {
    let token = localStorage.getItem('token');
    let headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Accept': '*/*',
    });
    return this.http.put<any>(`${this.apiUrl}release/updateApproval`, data, { headers: headers });
  }

}
